import React from 'react';
import PropTypes from 'prop-types';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        console.log(this.props.content);
        const { content } = this.props;

        return (
            <React.Fragment>
                <div style={{ width: 825, margin: '20px auto 0' }}>
                    <h1 style={{ fontSize: 24, height: 32, lineHeight: '32px', marginBottom: 20 }}>{content.title}</h1>
                    <div style={{ fontSize: 14, marginBottom: 20, textIndent: '2em' }}>{content.description}</div>
                    <video
                        src={content.videoPlayUrl}
                        controls
                        style={{ width: '100%', margin: '0 auto', outline: 'none' }}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default Layout;
